module.exports = __webpack_public_path__ + "static/media/me.898b8759.jpg";